import { render, staticRenderFns } from "./AccountSetup.vue?vue&type=template&id=661153c4&scoped=true&"
import script from "./AccountSetup.vue?vue&type=script&lang=js&"
export * from "./AccountSetup.vue?vue&type=script&lang=js&"
import style0 from "./AccountSetup.vue?vue&type=style&index=0&id=661153c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661153c4",
  null
  
)

export default component.exports